module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/group-1d766e98be3a94802c9c2ad1265abf40.svg";